import React, { useState } from "react";
import axios from "../../services/api";
import { Helmet } from "react-helmet";
import "./styles/Contact.css";

function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setIsSubmitting(true);
    try {
      await axios.post("/contact", form);
      setSuccess("Mesajınız uğurla göndərildi! Ən qısa zamanda cavab verəcəyik.");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      setError("Xəta baş verdi. Zəhmət olmasa yenidən cəhd edin.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="ct-page">
      <Helmet>
        <title>Əlaqə – HeyatYolu</title>
        <meta name="description" content="Bizimlə əlaqə saxlayın. HeyatYolu komandası sizə cavab verməyə hazırdır." />
        <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400&family=Noto+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      </Helmet>

      {/* ═══ HERO ═══ */}
      <header className="ct-hero">
        <div className="ct-hero__bg"></div>
        <div className="ct-hero__inner">
          <span className="ct-hero__label">ƏLAQƏ</span>
          <h1 className="ct-hero__title">
            Sizə kömək etmək<br />
            <em>üçün buradayıq</em>
          </h1>
          <p className="ct-hero__sub">
            Sevdiklərinizin xatirələrini qorumaqda hər addımda yanınızdayıq.
            Suallarınız, təklifləriniz — hər şey bizim üçün dəyərlidir.
          </p>
        </div>
      </header>

      {/* ═══ MAIN ═══ */}
      <section className="ct-main">
        <div className="ct-main__inner">

          {/* LEFT — Contact Info */}
          <div className="ct-info">
            <div className="ct-info__section">
              <span className="ct-info__label">BİZƏ YAZIN</span>
              <h2 className="ct-info__title">Əlaqə Məlumatları</h2>
              <p className="ct-info__desc">
                İstənilən vaxt bizimlə əlaqə saxlaya bilərsiniz. Komandamız hər mesajı
                diqqətlə oxuyur və ən qısa zamanda cavab verir.
              </p>
            </div>

            <div className="ct-channels">
              <a href="tel:+994503424174" className="ct-channel ct-channel--phone">
                <div className="ct-channel__icon">
                  <i className="fas fa-phone-alt"></i>
                </div>
                <div className="ct-channel__body">
                  <span className="ct-channel__name">Telefon</span>
                  <span className="ct-channel__value">+994 50 342 41 74</span>
                </div>
                <i className="fas fa-arrow-right ct-channel__arrow"></i>
              </a>

              <a href="mailto:heyatyolu.az@gmail.com" className="ct-channel ct-channel--email">
                <div className="ct-channel__icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="ct-channel__body">
                  <span className="ct-channel__name">Email</span>
                  <span className="ct-channel__value">heyatyolu.az@gmail.com</span>
                </div>
                <i className="fas fa-arrow-right ct-channel__arrow"></i>
              </a>

              <a href="https://instagram.com/heyatyolu.az" target="_blank" rel="noopener noreferrer" className="ct-channel ct-channel--insta">
                <div className="ct-channel__icon">
                  <i className="fab fa-instagram"></i>
                </div>
                <div className="ct-channel__body">
                  <span className="ct-channel__name">Instagram</span>
                  <span className="ct-channel__value">@heyatyolu.az</span>
                </div>
                <i className="fas fa-arrow-right ct-channel__arrow"></i>
              </a>
            </div>

            {/* Support card */}
            <div className="ct-support">
              <div className="ct-support__icon">🤝</div>
              <div className="ct-support__body">
                <strong>Kədər Dəstəyi</strong>
                <p>Sevdiyinizi itirdiyiniz bu çətin zamanda tək deyilsiniz.
                  Komandamız 24/7 sizə dəstək olmağa hazırdır.</p>
              </div>
            </div>
          </div>

          {/* RIGHT — Form */}
          <div className="ct-form-wrap">
            <div className="ct-form-card">
              <div className="ct-form-card__header">
                <h3>Mesaj Göndərin</h3>
                <p>Suallarınızı və rəylərinizi bizimlə bölüşün</p>
              </div>

              <form onSubmit={handleSubmit} className="ct-form">
                <div className="ct-form__row">
                  <div className="ct-form__group">
                    <label className="ct-form__label">Ad</label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Adınız..."
                      required
                      value={form.name}
                      onChange={handleChange}
                      className="ct-form__input"
                    />
                  </div>
                  <div className="ct-form__group">
                    <label className="ct-form__label">Email</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="email@nümunə.az"
                      required
                      value={form.email}
                      onChange={handleChange}
                      className="ct-form__input"
                    />
                  </div>
                </div>

                <div className="ct-form__group">
                  <label className="ct-form__label">Mesaj</label>
                  <textarea
                    name="message"
                    placeholder="Sizə necə kömək edə bilərik?..."
                    required
                    rows="5"
                    value={form.message}
                    onChange={handleChange}
                    className="ct-form__textarea"
                  ></textarea>
                </div>

                {error && (
                  <div className="ct-alert ct-alert--error">
                    <i className="fas fa-exclamation-circle"></i>
                    <span>{error}</span>
                  </div>
                )}

                {success && (
                  <div className="ct-alert ct-alert--success">
                    <i className="fas fa-check-circle"></i>
                    <span>{success}</span>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="ct-form__btn"
                >
                  {isSubmitting ? (
                    <>
                      <div className="ct-form__spinner"></div>
                      Göndərilir...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-paper-plane"></i>
                      Mesajı Göndər
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;